import { AnyAction } from '@reduxjs/toolkit';
import { REQ_DATA } from '../../constants/actionTypes';

export interface RequestsState {
  requests: unknown[];
}

const initialState: RequestsState = {
  requests: [],
};

export default function requestsReducers(
  state: RequestsState = initialState,
  action: AnyAction
): RequestsState {
  switch (action.type) {
    case REQ_DATA: {
      return {
        ...state,
        requests: (action as unknown as { payload: unknown[] }).payload,
      };
    }
    default:
      return state;
  }
}
